module.exports = __webpack_public_path__ + "static/media/UKLogo.814ecba5.png";